import { render, staticRenderFns } from "./Logboek.vue?vue&type=template&id=c99b7e8a&scoped=true"
import script from "./Logboek.vue?vue&type=script&lang=js"
export * from "./Logboek.vue?vue&type=script&lang=js"
import style0 from "./Logboek.vue?vue&type=style&index=0&id=c99b7e8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99b7e8a",
  null
  
)

export default component.exports